import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { AcceptanceCriteria } from '../../core/models/acceptance-criteria.model';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-acceptance-criteria-detail',
  templateUrl: './acceptance-criteria-detail.component.html',
  styleUrls: ['./acceptance-criteria-detail.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class AcceptanceCriteriaDetailComponent implements OnInit {
  @Input() criteria: AcceptanceCriteria | null = null; // Recibir el criterio de aceptación
  @Output() closeDetail = new EventEmitter<void>(); // Emitir evento para cerrar el detalle

  constructor() {}

  ngOnInit(): void {}

  close() {
    this.closeDetail.emit(); // Emitir evento de cerrar
  }
}
